import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { TextBoxSC } from 'atoms/TextBox'
import { FIXED_INDENTS } from 'vars/index'
import { Card } from '../Card'

export const SidebarCardStyled = styled(Card)`
  width: ${({ aspectRatio }) =>
    `calc(var(--sidebar-card-height) * ${aspectRatio})`};
  height: var(--sidebar-card-height);
`

export const CardContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(${FIXED_INDENTS.INDENT_30});
  position: relative;

  &::after {
    content: ' ';
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }

  ${ButtonSC} {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${TextBoxSC} {
    z-index: 2;
    align-self: flex-end;
  }
`
